import { Stepper } from '../../shared/components/Stepper';
import { SignUpStep } from '../sign-up-page/SignUpStep';
import { VerificationStep } from '../verification-page/VerificationStep';

export const SignUpPage = (): JSX.Element => {
  const SignUpSteps = [SignUpStep, VerificationStep];
  return <Stepper steps={SignUpSteps} />;
};
